export interface ICollectionTileContainerProps {
  columnCount: number;
  tileCount: number;
}

interface ICollectionTileContainerStyledProps {
  $columnCount: number;
  $tileCount: number;
}

export interface ICollectionVideoTileContainerStyledPropTypes
  extends ICollectionTileContainerStyledProps {
  $videoDimensions?: ICollectionVideoDimensions;
}

export interface ICollectionVideoDimensions {
  width: number;
  height: number;
}

interface IGridPositioning {
  gridColumn: string;
  gridRow: string;
}

export const DESKTOP_COLUMN_COUNT = 5;
export const TABLET_COLUMN_COUNT = 4;
export const MOBILE_COLUMN_COUNT = 2;

const ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD = 0.8;
const ASPECT_RATIO_SQUARE_UPPER_THRESHOLD = 1.1;

export const getVideoAspectRatio = (
  videoDimensions?: ICollectionVideoDimensions
): number => {
  if (videoDimensions && videoDimensions.height > 0) {
    return videoDimensions.width / videoDimensions.height;
  }

  return 1.6;
};

export const determineVideoGridPositioning = ({
  $tileCount,
  $columnCount,
  $videoDimensions,
}: ICollectionVideoTileContainerStyledPropTypes): IGridPositioning => {
  const aspectRatio = getVideoAspectRatio($videoDimensions);

  if ($columnCount === MOBILE_COLUMN_COUNT) {
    if (aspectRatio < ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD) {
      return {
        gridColumn: "1 / span 2",
        gridRow: "3 / span 2",
      };
    } else {
      return {
        gridColumn: "1 / span 2",
        gridRow: "3",
      };
    }
  }

  if (
    ($columnCount === DESKTOP_COLUMN_COUNT ||
      $columnCount === TABLET_COLUMN_COUNT) &&
    $tileCount <= 10
  ) {
    if (aspectRatio < ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD) {
      return {
        gridColumn: "1 / span 2",
        gridRow: "2 / span 2",
      };
    } else if (aspectRatio < ASPECT_RATIO_SQUARE_UPPER_THRESHOLD) {
      return {
        gridColumn: "1 / span 2",
        gridRow: "2",
      };
    } else {
      return {
        gridColumn: "1 / span 3",
        gridRow: "2",
      };
    }
  }

  if (aspectRatio < ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD) {
    return {
      gridColumn: "1 / span 2",
      gridRow: "3 / span 2",
    };
  } else if (aspectRatio < ASPECT_RATIO_SQUARE_UPPER_THRESHOLD) {
    return {
      gridColumn: "1 / span 2",
      gridRow: "3",
    };
  } else {
    return {
      gridColumn: "1 / span 3",
      gridRow: "3",
    };
  }
};
